import React from "react";
import { Shindan } from "./shindan";
import { useShindan } from "../../hooks/use-shindan";

const ShindanContainer: React.FC = () => {
  return <Shindan {...useShindan()} />;
};

export default ShindanContainer;
